export default __webpack_public_path__ + "static/media/Wheel-Wedge-Orange.53dfc760.png";